import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { WebsocketV1 } from 'src/AppState/websocketV1/WebsocketV1';
import { UserModel } from './UserModel';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { TrpcClient } from 'src/AppState/TrpcClient';

export class ModelsState {
    private readonly users: AutoMap<number, UserModel>;

    public constructor(websocketV1: WebsocketV1, sdk: SdkStaff, trpcClient: TrpcClient) {
        this.users = new AutoMap((userId: number) => new UserModel(sdk, websocketV1, userId, trpcClient));
    }

    public getUserModel(userId: number): UserModel {
        return this.users.get(userId);
    }
}
